import testimonials from '~/languages/en/doctors/testimonials.js';
import demo from '~/languages/en/doctors/demo.js';
import info from '~/languages/en/doctors/info.js';

export default {
  testimonials,
  demo,
  info,
};
